import { z } from 'zod';

import { isStringExactly } from '@occc-app/lib/constants/validationMessages';
import { makeZodValidate } from '@occc-app/design-system';

export const enterOTPSchema = z.object({
  otp: z.string().length(6, isStringExactly(6)),
});

export const validateEnterOTP = makeZodValidate(enterOTPSchema);
